module.exports = __webpack_public_path__ + "img/flag--no.859a1356.svg";